import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoaderService } from '../../../Services/loader.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loader = inject(LoaderService);
  const skip_loading = req.headers.get('skip-loading') === 'true';

  if (!skip_loading) {
    loader.show();
  }

  return next(req).pipe(
    finalize(() => {
      if (!skip_loading) {
        loader.hide();
      }
    }),
  );
};
